import { Box, Button, Checkbox, Typography } from "@mui/material";
import HeaderSection from "./header-section";
import MoreSection from "./sections/more";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { setSearchFilters } from "slices/searchListingReducer";

const MoreFilterSection = ({ onClose }: { onClose: any }) => {
  const { filters } = useAppSelector((state) => state.searchListingReducer);
  const [values, setValues] = useState(filters);
  const dispatch = useAppDispatch();

  useEffect(() => {
    setValues(filters);
  }, [filters]);

  return (
    <Box sx={{ width: "600px" }}>
      <HeaderSection
        label="More"
        disabledClearAll={!Object.keys(values)?.length}
        onClearAll={() => {
          setValues({});
        }}
        onClose={onClose}
      />

      <MoreSection value={values} onChange={setValues} />
      <Box
        sx={{
          my: "15px",
          mx: "4%",
          // position: "absolute",
          // width: "100%",
          // right: 0,
          // bottom: 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            sx={{ height: "48px", borderRadius: "10px" }}
            variant="contained"
            onClick={() => {
              dispatch(setSearchFilters(values));
              onClose();
            }}
          >
            Apply Filter
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default MoreFilterSection;
